import { useQuery } from '@tanstack/react-query';
import {
  emptyWorkOrdersListFilters,
  strapiListWorkOrders,
  type WorkOrdersListFilters,
} from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useWorkOrdersQuery(
  jwt: string | null,
  filters: WorkOrdersListFilters = emptyWorkOrdersListFilters,
) {
  return useQuery({
    queryKey: queryKeys.workOrders(jwt, filters),
    queryFn: () => strapiListWorkOrders(jwt!, 200, filters),
    enabled: Boolean(jwt),
  });
}
